import React from "react"
import {EvaluationFlags, IdTheftScore} from "../EvaluationFlags/EvaluationFlags"
import {IndividualProductApplication} from "../../resources/productApplication"

interface EvaluationFlagsIndividualProductApplicationProps {
	application: IndividualProductApplication
}

export default function EvaluationFlagsIndividualProductApplication({
	application,
}: EvaluationFlagsIndividualProductApplicationProps) {
	return (
		<div className="card has-full-height">
			<div className="card-header">
				<p className="card-header-title">Evaluation Flags</p>
			</div>
			<div className="card-content">
				<EvaluationFlags title="Individual" flags={application.attributes.evaluationFlags} />
				{application.attributes.idTheftScore ? (
					<IdTheftScore idTheftScore={application.attributes.idTheftScore} />
				) : null}
			</div>
		</div>
	)
}
